
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class ReceiptMaterialGrid extends Serenity.EntityGrid<ReceiptMaterialRow, any> {
        protected getColumnsKey() { return 'Production.ReceiptMaterial'; }
        protected getDialogType() { return ReceiptMaterialDialog; }
        protected getIdProperty() { return ReceiptMaterialRow.idProperty; }
        protected getInsertPermission() { return ReceiptMaterialRow.insertPermission; }
        protected getLocalTextPrefix() { return ReceiptMaterialRow.localTextPrefix; }
        protected getService() { return ReceiptMaterialService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(71);
            this.editItem(<ReceiptMaterialRow>{
                VoucherNo: voucherNo,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                EmployeeId: 0,
                VoucherTypeId: 71,
                TransDate: now.toDateString()

            });
        }
    }
}